import { connect } from 'react-redux';

import LoginModalComponent from '../Components/LoginModalComponent.jsx';
import { modal as modalActions } from '../actions';
import { getModalVisibility, getModalInfoByOwner } from '../reducers';
import { owners } from '../helpers/modals';

export const mapStateToProps = (state) => {
  return {
    visible: getModalVisibility(state, owners.jiraLogin),
    redirectFunc: getModalInfoByOwner(state, owners.jiraLogin).redirectFunc,
  };
};

export default connect(
  mapStateToProps,
  { onHide: () => modalActions.showJiraLoginModal(false) }
)(LoginModalComponent);


// WEBPACK FOOTER //
// src/Containers/LoginModalContainer.jsx